import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    standalone: false
})
export class HistoryComponent {
  displayedColumns: string[] = ['dateUpdated', 'className', 'property', 'oldValue', 'newValue', 'userUpdated'];
  constructor(
    public dialogRef: MatDialogRef<HistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
}
